export default "__VITE_ASSET__d176661c__"